module.exports = __webpack_public_path__ + "img/html-evolution-10.a45c51f7.jpg";